/**
 * Participants Page Constants
 */

export const TAB_TYPES = {
  TEAMS: "teams",
  REFEREES: "referees",
  ADMINISTRATORS: "administrators",
};

export const MODAL_TYPES = {
  TEAM: "team",
  MANUAL_TEAM: "manual-team",
  REFEREE: "referee",
  ADMIN: "admin",
};

export const STATUS_STYLES = {
  ACCEPTED: "bg-green-500/10 text-green-400",
  APPROVED: "bg-green-500/10 text-green-400",
  active: "bg-green-500/10 text-green-400",
  PENDING: "bg-yellow-500/10 text-yellow-400",
  default: "bg-red-500/10 text-red-400",
};

export const STATUS_LABELS = {
  APPROVED: "Accepted",
  ACCEPTED: "Accepted",
  PENDING: "Pending",
  active: "Active",
};

export const getStatusStyle = (status) => {
  return STATUS_STYLES[status] || STATUS_STYLES.default;
};

export const SORT_OPTIONS = [
  { value: "status", label: "Registered" },
  { value: "name-asc", label: "Name (A-Z)" },
];

export const STATUS_PRIORITY = {
  ACCEPTED: 0,
  APPROVED: 0,
  active: 0,
  PENDING: 1,
  default: 2,
};

export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50];

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (email) => EMAIL_REGEX.test(email);
